import MainSection from '@/components/common/MainSection/MainSection';

const IoSettingsId = () => {
  return <MainSection isEditMode origin="insertionOrder" />;
};

export default IoSettingsId;
